import { TreeSelect } from 'antd';
import { TreeNode } from 'rc-tree-select';
export { TreeNode };
export default TreeSelect;
